module.exports = __webpack_public_path__ + "static/media/d.d8c030b6.svg";